/**
 * Keeps already-authenticated customers off the login page — the header's user
 * icon goes straight to the account area, so there is no reason to see it again.
 */
export default defineNuxtRouteMiddleware((to) => {
  const { isLoggedIn } = useCustomerStore()
  if (!isLoggedIn) return

  return navigateTo(safeRedirect(to.query.redirect) ?? useLocalePath()('/'))
})
